import { identity } from "es-toolkit";

import { TGeolocatedSiteAddress, TPostalSiteAddress, TSiteAddress } from "@/data/api/kili/sites/types/sites.type";

export function formatPostalAddressStreet(address?: TPostalSiteAddress | null) {
  return [address?.streetNumber, address?.street].filter(Boolean).join(" ");
}

export function formatPostalAddressCity(address?: TPostalSiteAddress | null) {
  return [address?.postalCode, address?.city].filter(Boolean).join(" ");
}

export function formatCompletePostalAddress(address?: TPostalSiteAddress | null) {
  return [formatPostalAddressStreet(address), formatPostalAddressCity(address)].filter(Boolean).join(" ");
}

export function formatGeolocatedAddressStreet(address?: TGeolocatedSiteAddress | null) {
  return [address?.streetNumber, address?.street].filter(Boolean).join(" ");
}

export function formatGeolocatedAddressCity(address?: TGeolocatedSiteAddress | null) {
  return [address?.postalCode, address?.city].filter(Boolean).join(" ");
}

export function formatCompleteGeolocatedAddress(address?: TGeolocatedSiteAddress | null) {
  return [formatGeolocatedAddressStreet(address), formatGeolocatedAddressCity(address)].filter(Boolean).join(" ");
}

export function hasPostalAddress(address?: TSiteAddress) {
  return [
    address?.postalSiteAddress?.street,
    address?.postalSiteAddress?.postalCode,
    address?.postalSiteAddress?.city,
  ].every((k) => !!identity(k));
}
